import React from 'react'
import CardWidget, { Colors } from '../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import { formatCurrency } from '../../../../utils/Helpers'

type Props = {
  totalDeliveredTicketAverage: number
}

const TotalTicketAverage = ({ totalDeliveredTicketAverage }: Props): JSX.Element => {
  if (!totalDeliveredTicketAverage && totalDeliveredTicketAverage !== 0) return <CardWidgetSkeleton />

  return (
    <CardWidget title='Ticket médio geral (pedido)' number={formatCurrency(totalDeliveredTicketAverage)} color={Colors.grey} />
  )
}

export default TotalTicketAverage
